import { ref, computed } from 'vue';
import LaisWhatsappConnectionsAPI from 'dashboard/api/laisWhatsappConnections';

/**
 * WhatsApp Web (Evolution) connections available as a campaign sender.
 *
 * Only connections that are live AND already mirrored into a Chatwoot inbox can
 * drive a dispatch — the backend refuses the others — so the form never offers a
 * sender that would fail at trigger time.
 */
export function useCampaignWhatsappConnections() {
  const connections = ref([]);
  const isLoading = ref(false);
  const hasLoaded = ref(false);
  const isEvolutionConfigured = ref(true);

  const readyConnections = computed(() =>
    connections.value.filter(
      connection => connection.active && connection.inbox?.id
    )
  );

  const connectionOptions = computed(() =>
    readyConnections.value.map(connection => ({
      value: connection.id,
      label:
        connection.profile_name ||
        connection.phone_number ||
        connection.instance_name,
    }))
  );

  const fetchConnections = async () => {
    isLoading.value = true;
    try {
      const { data } = await LaisWhatsappConnectionsAPI.list();
      connections.value = data?.data ?? [];
      isEvolutionConfigured.value = data?.meta?.evolution_configured ?? true;
    } catch (error) {
      connections.value = [];
    } finally {
      isLoading.value = false;
      hasLoaded.value = true;
    }
  };

  const findConnection = id =>
    connections.value.find(connection => connection.id === id) ?? null;

  return {
    connections,
    readyConnections,
    connectionOptions,
    isLoading,
    hasLoaded,
    isEvolutionConfigured,
    fetchConnections,
    findConnection,
  };
}
